module.exports = __webpack_public_path__ + "static/silvestre-a2685d133175cbace815159935946878.svg";